import React from 'react'

export default function ResetButtons({ onclick, text }) {
    return (
        <div className='resetBtn'>
            <button onClick={onclick}>{text}</button>
        </div>
    )
}
